<ui-page-header [pageTitle]="'Katalog skupin typu oprávnění k zastupování'">
  <reza-katalog-skupin-sablon-overview-filter
    (handleLazyLoad)="onLazyLoad($event)"
    (handleSubmitFilter)="handleSubmitFilter($event)"
    (handleClearFilter)="handleClearFilter($event)"></reza-katalog-skupin-sablon-overview-filter>
</ui-page-header>
